/* DBG-CONSENT-01/02: custom cookie bar on Shopify's Customer Privacy API. Records a choice only on a click.
   Also holds the newsletter popup (jQuery modal on #popup) until the visitor has chosen, in regions where consent is required. */
(function () {
  var bar = document.getElementById('dbg-cb');
  if (!bar) return;
  var shown = false, done = false;

  /* popup hold: in consent regions the newsletter popup waits for a cookie choice; elsewhere it is released at once */
  var holding = true, held = [];
  function release(delay) {
    if (!holding) return;
    holding = false;
    var run = function () { held.splice(0).forEach(function (f) { try { f(); } catch (e) {} }); };
    if (held.length) setTimeout(run, delay || 0);
  }
  (function wrap(tries) {
    var jq = window.jQuery;
    if (!jq || !jq.fn || !jq.fn.modal) { if (tries < 100) setTimeout(function () { wrap(tries + 1); }, 50); return; }
    if (jq.fn.modal.dbgHold) return;
    var orig = jq.fn.modal;
    var w = function () {
      var self = this, args = arguments;
      if (holding && self.is && self.is('#popup')) { held.push(function () { orig.apply(self, args); }); return self; }
      return orig.apply(this, arguments);
    };
    w.dbgHold = true;
    jq.fn.modal = w;
  })(0);

  function show() {
    if (shown || done) return;
    shown = true;
    bar.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { bar.classList.add('on'); }); });
  }
  function hide() {
    done = true;
    bar.classList.remove('on');
    setTimeout(function () { bar.hidden = true; }, 800);
    release(900);
  }
  function whenReady(cp) {
    var hero = document.querySelector('[data-dbg="hero"]') || document.querySelector('.video-with-image-section');
    var v = hero && hero.querySelector('video');
    var yt = hero && hero.querySelector('.video__iframe, iframe[src*="youtube"]');
    if (bar.dataset.home && hero && (v || yt)) {
      var last = 0;
      if (v) v.addEventListener('timeupdate', function () { if (v.currentTime < last - 1) show(); last = v.currentTime; });
      if (yt) window.addEventListener('message', function (e) {
        if (!/^https:\/\/www\.youtube(-nocookie)?\.com$/.test(e.origin)) return;
        var d = e.data;
        if (typeof d === 'string') { try { d = JSON.parse(d); } catch (x) { return; } }
        if (d && ((d.event === 'onStateChange' && d.info === 0) || (d.event === 'infoDelivery' && d.info && d.info.playerState === 0))) show();
      });
      var check = function () { if (window.scrollY > hero.offsetHeight * 0.6) show(); };
      window.addEventListener('scroll', check, { passive: true });
      check();
    } else {
      show();
    }
  }
  function record(ok) {
    var cp = Shopify.customerPrivacy;
    hide();
    try {
      cp.setTrackingConsent({ analytics: ok, marketing: ok, preferences: ok }, function () {
        try { cp.setTrackingConsent({ sale_of_data: ok }, function () {}); } catch (e) {}
      });
    } catch (e) {}
  }
  function settings() {
    var pb = window.privacyBanner;
    if (pb && pb.showPreferences) { try { pb.showPreferences(); return; } catch (e) {} }
    /* fallback: reveal Shopify's own dialog so the visitor can still choose */
    document.documentElement.classList.add('dbg-cb-native');
    hide();
  }

  if (!window.Shopify || !Shopify.loadFeatures) { release(0); return; }
  Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (err) {
    if (err) { release(0); return; }
    var cp = Shopify.customerPrivacy;
    if (!cp || !cp.shouldShowBanner || !cp.shouldShowBanner()) { release(0); return; }
    whenReady(cp);
  });

  bar.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    var c = b.getAttribute('data-c');
    if (c === 'accept') record(true);
    else if (c === 'decline') record(false);
    else if (c === 'settings') settings();
  });
  document.addEventListener('visitorConsentCollected', hide);
})();
